import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorGlobalRoute: InvariantJiraRoute = {
	name: 'global-issue-navigator',
	path: '/issues',
	// `jql?` distinguishes distinct-JQL NIN URLs for prefetch dedup (always-on; see EM-12530).
	query: ['filter?', 'jql?'],
};
